import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';
import store from 'redux/store';

export const reqTransform = {
  fetchPlatformCharges(params = {}) {
    const qsParams = {
      commodity_req_offer_id: params,
    };
    return utils.getQs(qsParams);
  },

  fetchPlatformChargesAuction(params = {}) {
    const qsParams = params;
    // const qsParams = {
    //   commodity_auction_master_id: params,
    // };
    return utils.getQs(qsParams);
  },

  fetchPlatformChargesCommon(params = {}) {
    const qsParams = params;
    return utils.getQs(qsParams);
  },
};

export const resTransform = {
  fetchPlatformCharges(resData) {
    let data = {
      ...resData,
      id: 0,
    };
    return data;
  },

  fetchPlatformChargesAuction(resData) {
    let data = {
      ...resData,
      id: 0,
    };
    return data;
  },

  fetchPlatformChargesCommon(resData) {
    let data = {
      ...resData,
      id: 0,
    };
    return data;
  },
};
